define(["ksc-breakpoint-notifier"], function (notifier) {
    function BreakpointNotifierViewModel(initObject) {
        notifier.init({
            fullResponsive: initObject.fullResponsive
        });
    }

    return BreakpointNotifierViewModel;
});